import {combineReducers} from 'redux';
import {resetMenuModelsAction, switchMenuStyleAction} from 'appmodule/home/action/MenuAction';
import _ from 'lodash';
import {createReducer} from 'util/redux';
import {EvoMenuTO} from 'generated/JavaTO';
import {MenuStyle} from 'appmodule/home/type/MenuStyle';
import moment from 'moment';

const Items = createReducer<EvoMenuTO[]>([], builder => builder
	.addCase(resetMenuModelsAction, (state, {payload}) =>
		_.isEqual(state, payload) ? state : payload,
	),
)

const menuStyle = createReducer(MenuStyle.Icon, builder => builder
	.addCase(switchMenuStyleAction, (state, {payload}) => payload),
)

const refreshTS = createReducer<number>(0, builder => builder
	.addCase(resetMenuModelsAction, () => +moment()),
)

export const MenuReducerNS = {
	Menu: combineReducers({
		Items,
		menuStyle,
		refreshTS,
	}),
}
export type MenuStateType = { Menu: ReturnType<typeof MenuReducerNS.Menu> }